<div class="welcome-message-container">
  <dgx-components-icon
    class="message-bot-icon"
    name="message-bot"
    size="lg"
  ></dgx-components-icon>
  <p class="title">D&G Smart-Fix</p>
  <p class="title">Welcome to our virtual assistant</p>
</div>
